import React from 'react';
import { ShieldCheck, Handshake, Clock } from 'lucide-react';
import { SectionLabel } from './SectionLabel';
const PILLARS = [{
  icon: ShieldCheck,
  title: 'Quality craftsmanship',
  copy: 'Done right the first time, with attention to the details most people never see.'
}, {
  icon: Handshake,
  title: 'Honest service',
  copy: 'Clear communication, transparent pricing, and no surprises mid-project.'
}, {
  icon: Clock,
  title: 'Dependable results',
  copy: 'We show up, we finish, and we stand behind the work long after the last walkthrough.'
}];
export function AboutSection() {
  return <section id="about" className="w-full bg-bone-50 py-24 sm:py-32" aria-labelledby="about-heading" data-id="element-14" data-mp="u7pszm0yudvu">
      <div className="mx-auto max-w-[1320px] px-6 lg:px-10" data-id="element-15" data-mp="q7p0ixh1825s">
        <div className="grid gap-14 lg:grid-cols-12" data-id="element-16" data-mp="2ojxiukyfk4kr">
          <div className="lg:col-span-5" data-id="element-17" data-mp="2kjnbp4ywj84b">
            <SectionLabel data-id="element-18" data-mp="2kkygn8432lx0">About Us</SectionLabel>
            <h2 id="about-heading" className="mt-7 font-display text-4xl font-light leading-[1.05] text-pine-950 sm:text-5xl" data-id="element-19" data-mp="2pcxjgo7orjpl">
              Locally owned. Personally accountable.
            </h2>
            <p className="mt-7 text-base leading-relaxed text-pine-950/70" data-id="element-20" data-mp="2gdaskwcl1was">
              Taylor Company is a locally owned business dedicated to quality
              craftsmanship, honest service, and dependable results. We take
              pride in treating every project as if it were our own home and
              building lasting relationships with our customers.
            </p>
            <figure className="mt-9 border-l border-pine-700/40 pl-6" data-id="element-21" data-mp="2zbwugdfxbrfr">
              <blockquote className="font-display text-xl font-light italic leading-relaxed text-pine-900" data-id="element-22" data-mp="33cp4va0j82dm">
                Guided by integrity, hard work, and faith, we give thanks to
                Jesus Christ for making all we do possible.
              </blockquote>
            </figure>
          </div>

          <div className="lg:col-span-6 lg:col-start-7" data-id="element-23" data-mp="9jc88xcy3ko2">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/dd7c1667-3cc0-41c7-8c11-9ab1946588af.jpg" alt="A Taylor Company carpenter leveling custom oak cabinetry during an interior renovation" className="aspect-[16/11] w-full rounded-2xl object-cover object-[center_35%]" data-id="element-24" data-mp="9it18bou2got" />
            <div className="mt-6 rounded-2xl bg-pine-950 p-9 sm:p-11" data-id="element-25" data-mp="3mqnpq09auwq3">
              <p className="text-[11px] uppercase tracking-widest2 text-pine-200" data-id="element-26" data-mp="3mryua2akk8i9">
                What guides the work
              </p>
              <ul className="mt-9 space-y-9" role="list" data-id="element-27" data-mp="3dx0xul87qdm6">
                {PILLARS.map(pillar => <li key={pillar.title} className="flex gap-5 border-b border-white/10 pb-9 last:border-0 last:pb-0" data-id="element-28" data-mp="38zimko6q3mb0">
                    <pillar.icon className="mt-1 h-5 w-5 shrink-0 text-pine-200" aria-hidden="true" data-id="element-29" data-mp="2z0tf7pcgdk90" />
                    <div data-id="element-30" data-mp="2oypfd3l683fm">
                      <h3 className="font-display text-2xl font-normal text-bone-50" data-id="element-31" data-mp="2tvfthldf0oye">
                        {pillar.title}
                      </h3>
                      <p className="mt-2 text-sm leading-relaxed text-bone-100/65" data-id="element-32" data-mp="2yvbzfq5oaqgl">
                        {pillar.copy}
                      </p>
                    </div>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}